var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "yf-bar" }, [
    _c(
      "div",
      { staticClass: "yf-label" },
      [
        _c("fa", {
          staticClass: "yf-label-ico",
          attrs: { icon: ["fas", "filter"] },
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Year")]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "yf-divider" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "yf-items" },
      _vm._l(_vm.years, function (year) {
        return _c(
          "label",
          {
            key: year,
            staticClass: "yf-item",
            class: { "yf-item--on": _vm.selectedYears.includes(year) },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedYears,
                  expression: "selectedYears",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                value: year,
                checked: Array.isArray(_vm.selectedYears)
                  ? _vm._i(_vm.selectedYears, year) > -1
                  : _vm.selectedYears,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.selectedYears,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = year,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.selectedYears = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.selectedYears = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.selectedYears = $$c
                    }
                  },
                  function ($event) {
                    return _vm.$emit("yearFilterChanged", _vm.selectedYears)
                  },
                ],
              },
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "yf-swatch",
              style: { background: _vm.yearColor(year) },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "yf-year" }, [_vm._v(_vm._s(year))]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }